<template>
  <v-col
    cols="12"
    class="header pa-0"
  >
    <EmailForm />
    <template>
      <v-app-bar
        class="mobile-menu mobile-header-buttons mobile-header-bar"
        dark
        app
      >
        <v-btn
          icon
          depressed
          text
          @click="goBack"
        >
          <v-icon large>chevron_left</v-icon>
        </v-btn>
        <div
          style="cursor: pointer"
          @click="goBack"
        >
          <b>
            {{ capitalize($i18n.t('back')) }}
          </b>
        </div>
        <v-spacer />
        <div class="mobile-header-object-title">
          <b>{{ selectedObject && selectedObject.objectName }}</b>
        </div>
        <v-spacer></v-spacer>
        <div class="justify-end">
          <v-btn
            icon
            depressed
            text
            @click="mobileShare()"
          >
            <v-icon small>fa-share</v-icon>
          </v-btn>
        </div>
        <v-app-bar-nav-icon @click="showRightMenu = !showRightMenu" />
      </v-app-bar>
    </template>
  </v-col>
</template>

<script>
import EmailForm from '../../Forms/_EmailForm'
import sharedMethods from '../../../methods/sharedMethods'

import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ObjectPageHeaderMobile',

  components: {
    EmailForm,
  },

  computed: {
    ...mapFields(Object.keys(state)),
  },

  methods: {
    ...sharedMethods,

    goBack() {
      window.history.back()
    },
  },
}
</script>

<style>
/*.mobile-menu .v-toolbar__content {
  height: 48px !important;
}*/
.mobile-weather-img {
  width: 30px;
}
.mobile-temp-value {
  font-size: 14px;
  color: white;
  text-align: right;
  font-weight: bold;
  padding-right: 5px;
}
.mobile-temp-img,
.mobile-temp-text {
  float: right;
}
.mobile-temp-text {
  padding-top: 10px;
  padding-right: 10px;
}
.mobile-temp-img {
  padding-top: 5px;
}
.theme--dark.v-toolbar {
  background-color: inherit !important;
}
.mobile-menu .theme--dark.v-toolbar {
  background-color: inherit !important;
}
.mobile-logo {
  padding-top: 58px;
  text-align: center;
}
.mobile-logo a img {
  max-height: 95px;
}
.mobile-flags {
  text-align: center;
}
.mobile-flags a {
  padding: 0 3px;
}
.mobile-flags a img {
  width: 25px;
  padding-top: 5px;
}
.temp_value {
  position: relative;
  top: -15px;
  font-size: 20px;
  color: white;
  font-weight: bold;
  margin: 0;
  padding: 0;
}
.mobile-header-object-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 10px;
  overflow: hidden;
}
</style>
